import * as React from 'react';
import {renderElement} from '../../../../utils';
import {useNumberInputContext} from '../../_context';

import {NumberInputSuffixView} from './NumberInputSuffix.styles';

export const NumberInputSuffix = () => {
  const {state} = useNumberInputContext();

  if (!state.suffix) return null;

  const suffix =
    typeof state.suffix === 'string'
      ? state.suffix
      : renderElement(state.suffix);

  return (
    <NumberInputSuffixView
      shouldShowTrailingControls={state.shouldShowTrailingControls}
    >
      {suffix}
    </NumberInputSuffixView>
  );
};
